import { makeAutoObservable } from "mobx"
import { TType } from "../types";

class UserStore {
    private _defaultType: TType
    private _defaultCoin: string
    private _defaultLong: string
    private _defaultShort: string


    constructor() {
        makeAutoObservable(this)

        this._defaultType = "futures"
        this._defaultCoin = ""
        this._defaultLong = ""
        this._defaultShort = ""
    }

    get defaultType() {
        return this._defaultType
    }

    get defaultCoin() {
        return this._defaultCoin
    }

    get defaultLong() {
        return this._defaultLong
    }

    get defaultShort() {
        return this._defaultShort
    }

    set defaultType(val: TType) {
        this._defaultType = val
    }

    set defaultCoin(val: string) {
        this._defaultCoin = val
    }

    set defaultLong(val: string) {
        this._defaultLong = val
    }

    set defaultShort(val: string) {
        this._defaultShort = val
    }


    loadDefaultOptions(query: string) {
        query = query.slice(1)
        const dict: Record<string, string | TType> = {}

        const pairs = query.split('&')
        for (const pair of pairs) {
            const [key, value] = pair.split('=')
            dict[key] = value
        }

        this.defaultType = dict.type as TType || this._defaultType
        this.defaultCoin = decodeURI(dict.coin) || decodeURI(this._defaultCoin)
        this.defaultLong = dict.long || this._defaultLong
        this.defaultShort = dict.short || this._defaultShort
    }
}

export default new UserStore()
